import React from 'react'

import { formatCount } from '@/features/sidebar/utils/sidebarHelpers.ts'
import { cn } from '@/utils/common'

export type CountPillProps = {
  count: number
  styles?: React.CSSProperties
  className?: string
}

const CountPill: React.FC<CountPillProps> = ({ count, styles, className }) => {
  const formattedCount = formatCount(count)
  if (!formattedCount) {
    return null
  }

  return (
    <span
      aria-label={`${count} notifications`}
      className={cn(
        'inline-flex items-center justify-center',
        'bg-[var(--Colors-Background-bg-primary)]',
        'border border-[var(--Colors-Border-border-primary)]',
        'text-[var(--Colors-Text-text-secondary-700)]',
        'font-medium',
        className
      )}
      style={{
        borderRadius: 'var(--radius-sm)',
        padding: 'var(--spacing-xxs) var(--spacing-sm)',
        boxShadow: '0 2px 3px 0 var(--Colors-Effects-Shadows-shadow-3xl_01)',
        minWidth: '22px',
        fontSize: 'var(--Font-size-text-xs)',
        lineHeight: 'var(--Line-height-text-xs)',
        ...styles,
      }}
    >
      {formattedCount}
    </span>
  )
}

CountPill.displayName = 'CountPill'

export default React.memo(CountPill)
